<template>
  <main
    ref="mainArea"
  >
    <transition
      :name="animationName"
      mode="out-in"
    >
      <keep-alive include="TransactionsModule">
        <router-view
          v-if="isAllLoaded"
        />
      </keep-alive>
    </transition>
  </main>
</template>

<script>

export default {
  name: 'MainArea',
  props: {
    animationName: {
      type: String,
      default: '',
    },
  },
  computed: {
    isAllLoaded() {
      return this.$store.getters.isAllLoaded;
    },
  },
};
</script>

<style lang="scss" scoped>
  main {
    position: relative;
    overflow-y: auto;
    grid-area: main;
    background-color: var(--background-bg-hex);
    transition: padding 1s;
    padding: 30px 60px 100px 60px;

    @media screen and (max-width: $mediumBreakpoint) {
      padding: 30px 35px 100px 35px;
    }

    @media screen and (max-width: $smallBreakpoint) {
      padding: 15px 10px 100px 10px;
    }
  }

  .main-view-enter-active,
  .main-view-leave-active {
    transition: transform 0.5s, opacity 0.5s;
  }

  .main-view-enter,
  .main-view-leave-to {
    opacity: 0;
    transform: translateY(15px);
    transition: transform 0.35s, opacity 0.35s;
  }

</style>
